export default __webpack_public_path__ + "static/media/Honored Belt of the Mound.83e0b955.jpg";